//dynamically created on buildtime
const offerRanges = [
  [
    "2026-01-24",
    "2026-02-10"
  ],
  [
    "2026-02-07",
    "2026-02-24"
  ],
  [
    "2026-02-21",
    "2026-03-10"
  ],
  [
    "2026-03-07",
    "2026-03-24"
  ],
  [
    "2026-03-21",
    "2026-04-07"
  ],
  [
    "2026-04-04",
    "2026-04-21"
  ],
  [
    "2026-04-18",
    "2026-05-05"
  ],
  [
    "2026-05-02",
    "2026-05-19"
  ],
  [
    "2026-05-16",
    "2026-06-02"
  ],
  [
    "2026-05-30",
    "2026-06-16"
  ],
  [
    "2026-06-13",
    "2026-06-30"
  ],
  [
    "2026-06-27",
    "2026-07-14"
  ],
  [
    "2026-07-11",
    "2026-07-28"
  ],
  [
    "2026-07-25",
    "2026-08-11"
  ],
  [
    "2026-08-08",
    "2026-08-25"
  ],
  [
    "2026-08-22",
    "2026-09-08"
  ],
  [
    "2026-09-05",
    "2026-09-22"
  ],
  [
    "2026-09-19",
    "2026-10-06"
  ],
  [
    "2026-10-03",
    "2026-10-20"
  ],
  [
    "2026-10-17",
    "2026-11-03"
  ],
  [
    "2026-10-31",
    "2026-11-17"
  ],
  [
    "2026-11-14",
    "2026-12-01"
  ],
  [
    "2026-11-28",
    "2026-12-15"
  ],
  [
    "2026-12-12",
    "2027-01-05"
  ]
];
exports.offerRanges = offerRanges